import { render } from "./skeleton.vue?vue&type=template&id=6ac27844&name=skeleton"
const script = {}

import "./skeleton.vue?vue&type=style&index=0&id=6ac27844&lang=less"

import exportComponent from "D:\\微客\\we_customer_guide\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__